var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash011(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M16 6.6582V5.8582C16 4.7381 16 4.17805 15.782 3.75022C15.5903 3.3739 15.2843 3.06794 14.908 2.87619C14.4802 2.6582 13.9201 2.6582 12.8 2.6582H11.2C10.0799 2.6582 9.51984 2.6582 9.09202 2.87619C8.71569 3.06794 8.40973 3.3739 8.21799 3.75022C8 4.17805 8 4.7381 8 5.8582V6.6582M10 12.1582V17.1582M14 12.1582V17.1582M3 6.6582H21M19 6.6582V17.8582C19 19.5384 19 20.3784 18.673 21.0202C18.3854 21.5847 17.9265 22.0436 17.362 22.3312C16.7202 22.6582 15.8802 22.6582 14.2 22.6582H9.8C8.11984 22.6582 7.27976 22.6582 6.63803 22.3312C6.07354 22.0436 5.6146 21.5847 5.32698 21.0202C5 20.3784 5 19.5384 5 17.8582V6.6582",
    stroke: "#9C9A9D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash011);
export default __webpack_public_path__ + "static/media/trash-011.0233f5b3902fd9527a1403618703c51a.svg";
export { ForwardRef as ReactComponent };